import {Column, Row, Switch} from '@vidazoo/ui-kit';
import React from 'react';
import {observer} from 'mobx-react';
import dayjs from 'dayjs';
import {useNotificationSettingsListContext} from '../context/SettingsListContext';
import MarkeredText from '../../../../../common/components/markered-text/MarkeredText';
import {ReactComponent as DeleteIcon} from '../../../../charts/list/assets/delete.svg';
import theme from '../view/theme.module.scss';

function entityUrl(app: string, params: any): string | undefined {
    if (!params?.entityId) return;
    switch (app) {
        case 'Nightwatch': return `https://vidazoo-nightwatch.herokuapp.com/test/${params.entityId}/edit`;
        case 'Vroku': return `https://os.vidazoo.com/app/vroku/edit-host?id=${params.entityId}`;
        case 'Alert Rules':
            if (params.entityType === 'Alert Rule') return `https://bo.vidazoo.com/alert-rule/${params.entityId}/edit`;
            if (params.entityType === 'Smart Alert') return `https://bo.vidazoo.com/smart-alert/${params.entityId}/edit`;
    }
}
export default observer(function SettingsTableRow({itemIndex, style}: {itemIndex: number; style: React.CSSProperties}) {
    const {model} = useNotificationSettingsListContext();
    const item = model.maskItems[itemIndex];
    if (!item) return null;
    const background = itemIndex % 2 ? 'var(--settings-row-odd-background)' : 'var(--settings-row-background)';
    const rowStyle = {...style, '--table-viewport-background-color': background,
        '--table-data-column-background-color': background, '--table-column-sticky-background-color': background} as React.CSSProperties;
    const pending = model.pendingIds.includes(item._id);
    const entityName = item.app === 'Alert Rules' && item.params?.entityType
        ? `${item.params.entityName} (${item.params.entityType})` : item.params?.entityName;
    const date = value => value ? dayjs(value).format('MMMM D, YYYY h:mm A') : '';
    return <Row style={rowStyle} index={itemIndex} data-notification-setting-id={item._id}>
        <Column colKey="name">{item.params?.entityId
            ? <a className={theme.nameLink} href={entityUrl(item.app, item.params)} target="_blank" rel="noopener noreferrer">{entityName}</a>
            : <span className={theme.caption}>{item.name}</span>}</Column>
        <Column colKey="app"><MarkeredText marker={model.getColumnSearchQuery('app')}>{item.app}</MarkeredText></Column>
        {(['notification', 'email', 'sms'] as const).map(key => <Column colKey={key} key={key}>
            <Switch className={theme.switch} name={key} label={{notification: 'Notification', email: 'Email', sms: 'Sms'}[key]}
                aria-label={`${key} for ${item.name}`} checked={!!item[key]} disabled={pending || (key === 'notification' && item.type === 'custom') || (key === 'sms' && !model.phone)}
                onChange={e => model.updateSetting(item._id, key, e.target.checked)}/>
        </Column>)}
        <Column colKey="created">{date(item.created)}</Column>
        <Column colKey="lastSent">{date(item.lastSent)}</Column>
        <Column colKey="actions"><button type="button" className={theme.iconAction} aria-label={`Delete ${item.name}`} disabled={pending}
            onClick={() => {model.promptDeleteItem = item;}}><DeleteIcon aria-hidden="true"/></button></Column>
    </Row>;
});
